import { Button, Typography, ButtonProps } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import AddIcon from "@mui/icons-material/Add";

type CustomDefaultProps = {
    label: string;
    customsx?: object;
    notFitContentWidth?: boolean;
    withoutendcon?: boolean;
    hasstartaddicon?: boolean;
};

export default function CustomButton(props: ButtonProps & CustomDefaultProps) {
    const { label, customsx, withoutendcon, hasstartaddicon } = props;
    return (
        <Button
            {...props}
            sx={{
                display: "inline-flex",
                height: "3rem",
                padding: "0rem 1.5rem;",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.625rem",
                flexShrink: 0,
                borderRadius: "1rem",
                background: props.disabled ? "#C8CDD0" : "#005499",
                textTransform: "none",
                // width: "fit-content",
                margin: "auto",
                ...customsx,
                "&:hover": {
                    backgroundColor: "#fff",
                    color: "#005499",
                    border: "1px solid #005499",
                    "& .MuiTypography-root": {
                        color: "#005499", // Nouvelle couleur de la typographie
                    },
                    "& .MuiSvgIcon-root": {
                        color: "#005499", // Nouvelle couleur de l'icône
                    },
                },
            }}
        >
            {hasstartaddicon ? (
                <AddIcon
                    sx={{
                        color: "#FFF",
                        width: "1.25rem",
                        height: "1.25rem",
                    }}
                />
            ) : null}
            <Typography
                sx={{
                    color: props.disabled ? "#7A8185" : "#FFF",
                    fontFamily: "Roboto",
                    fontSize: "1rem",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                }}
            >
                {label}
            </Typography>
            {withoutendcon ? null : (
                <EastIcon
                    sx={{
                        color: props.disabled ? "#7A8185" : "#FFF",
                        width: "1.25rem",
                        height: "1.25rem",
                    }}
                />
            )}
        </Button>
    );
}
